/**
 * Checks if a given feature flag is enabled in localStorage.
 * @param {string} featureFlag - The feature flag key to check.
 * @returns {boolean} True if enabled, false otherwise.
 */
export const isFeatureFlagEnabled = (featureFlag: string): boolean => {
  return localStorage.getItem(featureFlag) === 'true';
};
